<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M27 12h-.32l-1.5-3.74A2 2 0 0023.32 7H21a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2h2.31a3.48 3.48 0 006.3 0h4.63a3.48 3.48 0 006.3 0H27a2 2 0 002-2v-5a2 2 0 00-2-2zm-16.54 9A1.5 1.5 0 1112 19.5a1.5 1.5 0 01-1.54 1.5zm10.93 0A1.5 1.5 0 0120 20a1 1 0 00-.08-.38v-.11a1.5 1.5 0 111.5 1.5zM27 19h-2.16a3.48 3.48 0 00-6.9 0h-4A3.48 3.48 0 007 19H5V7h14v6.5a1 1 0 002 0V9h2.32l2 5H27zM28 25H4a1 1 0 000 2h24a1 1 0 000-2z"/></svg>